import ButtonCloseMainPopup from "../ButtonCloseMainPopup";
import './WorkShop.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import SoulStone from "../../../images/main_menu/soul_stone.png";
import DivineEssence from "../../../images/main_menu/divine_essence.png";
import React, {useState} from "react";
import WorkShopSlider from "./WorkShopSlider";
import BoxOpenWindow from "../offers/BoxOpenWindow";
import {isMobile} from "react-device-detect";


function WorkshopComponent() {

    const {user, openBox} = useTypedSelector(state => state.auth);
    const [activeAdvice, setActiveAdvice] = useState<'soulStone' | 'divineEssence' | null>(null);

    let classContainer = 'offerOpenBox';
    if (openBox !== false) {
        classContainer += ' offerOpenBoxActive';
    }

    let adviceFontSizeClass = 'adviceFontSizeClass14';
    if(isMobile){
        adviceFontSizeClass = 'adviceFontSizeClass10';
    }

    const toggleAdvice = (advice: 'soulStone' | 'divineEssence') => {
        setActiveAdvice((currentAdvice) => currentAdvice === advice ? null : advice);
    };

    const handleAdviceKeyDown = (
        event: React.KeyboardEvent<HTMLDivElement>,
        advice: 'soulStone' | 'divineEssence'
    ) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleAdvice(advice);
        }
    };

    return <div className='main-popup-container'>
        <ButtonCloseMainPopup/>
        <div className={'offersTitle'}>
            <div className={'offersTitleText'}>Workshop</div>
        </div>

        <div className={'workshopSoulStoneAmountContainer'}>
            <div className={'workshopAdvice ' + adviceFontSizeClass + (activeAdvice === 'soulStone' ? ' workshopAdviceActive' : '')}>
                1. Soul Stones replace the 6th copy from card boxes or season progress. <br />
                2. Soul Stones are also common in Season Pass rewards.
            </div>
            <div
                className={'workshopSoulStoneAmount workshopAdviceTrigger' + (activeAdvice === 'soulStone' ? ' workshopAdviceTriggerActive' : '')}
                onClick={() => toggleAdvice('soulStone')}
                onKeyDown={(event) => handleAdviceKeyDown(event, 'soulStone')}
                role='button'
                tabIndex={0}
                aria-expanded={activeAdvice === 'soulStone'}
            >
               Soul Stones: {user.soul_stone}
                <img className='workshopSoulStone' src={SoulStone as any} alt={'Soul Stone'}/>
            </div>
            <div
                className={'workshopDivineEssenceAmount workshopAdviceTrigger' + (activeAdvice === 'divineEssence' ? ' workshopAdviceTriggerActive' : '')}
                onClick={() => toggleAdvice('divineEssence')}
                onKeyDown={(event) => handleAdviceKeyDown(event, 'divineEssence')}
                role='button'
                tabIndex={0}
                aria-expanded={activeAdvice === 'divineEssence'}
            >
                 Divine Essence: {user.divine_essence}
                <img className='workshopDivine' src={DivineEssence as any} alt={'Divine Essence'}/>
            </div>
            <div className={'workshopAdvice ' + adviceFontSizeClass + (activeAdvice === 'divineEssence' ? ' workshopAdviceActive' : '')}>
                1. Divine Essence replaces the 6th Mythic copy. <br />
                2. Earned from bonus levels, Champion title, and full season progress.
            </div>
        </div>
        <div className='workshopYellowLine'></div>


        <WorkShopSlider/>

        <div className={classContainer}>
            {(openBox !== false) ?
                <BoxOpenWindow openBox={openBox}/>
                :
                <div></div>
            }
        </div>

    </div>

}

export default WorkshopComponent;
